import 'bootstrap/dist/css/bootstrap.min.css';
import 'katex/dist/katex.min.css';
import './index.css';
import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import App from "./App";
import { LanguageProvider } from "./contexts/LanguageContext";
import { ThemeProvider } from "./contexts/ThemeContext";
import { SubjectProvider } from "./contexts/SubjectContext";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <ThemeProvider>
      <LanguageProvider>
        <SubjectProvider>
          <BrowserRouter>
            <App />
          </BrowserRouter>
        </SubjectProvider>
      </LanguageProvider>
    </ThemeProvider>
  </React.StrictMode>
);